import { Outlet, useMatches } from '@tanstack/react-router';
import { useEffect } from 'react';
import AppLayout from '@excent-one/react/layout/app/AppLayout';
import AppUserAvatar from '@excent-one/react/layout/app/AppUserAvatar';
import { useAuthContext } from '@excent-one/auth';
import { appName, siteName } from '../config';
import fullSiteLogo from "@phrmpc/assets/images/brand/paramount_2xlogo_vertical.png";
import miniSiteLogo from "@phrmpc/assets/images/brand/img_paramount logo.png";

const AuthenticatedLayout = () => {
  const [{ currentUser }, { logout }] = useAuthContext();
  const matches = useMatches();

  useEffect(() => {
    const currentMatch = matches
      .filter((m) => (m.staticData as any)?.handle?.title != null)
      .at(-1);
    document.title =
      currentMatch != null
        ? `${appName} | ${(currentMatch.staticData as any).handle.title}`
        : appName;
  }, [matches]);

  return (
    <AppLayout appName={siteName}>
      <AppLayout.Header>
        <AppUserAvatar
          userName={currentUser?.displayName}
          emailAddress={currentUser?.email}
          onLogOut={() => logout({ redirectTo: '/auth/login' })}
        />
      </AppLayout.Header>
      <AppLayout.Drawer
        brandSettings={{
          expanded: { name: siteName, imageUrl: fullSiteLogo },
          collapsed: { name: siteName[0], imageUrl: miniSiteLogo },
        }}
      />
      <AppLayout.Content>
        <Outlet />
      </AppLayout.Content>
      <AppLayout.Footer />
    </AppLayout>
  );
};

export default AuthenticatedLayout;
